import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getSetPasswordLinkExpiredPath = () => urlHelper(`/password-recovery/link-expired`);
